import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/core/controls/base.component';
import { ShareDataService } from 'src/providers/sharedata.service';
import { GoodsModel } from 'src/models/goods.model';
import { GoodsGroupModel } from 'src/models/goodsgroup.model';

@Injectable()
export class UploadDownloadService extends BaseComponent {
  private baseApiUrl: string;
  private apiDownloadUrl: string;
  private apiUploadUrl: string;
  private apiFileUrl: any;

  sizeErr: number;
  typeErr: any;
  fileErr: string;

  fileUrl: any;
  fileName: string;

  gg: GoodsGroupModel;
  goods: GoodsModel;

  constructor(private httpClient: HttpClient,public share: ShareDataService) {
    super();
    this.baseApiUrl = this.api.apiUrl + '/api/';
    this.apiDownloadUrl = this.baseApiUrl + 'download';
    this.apiUploadUrl = this.baseApiUrl + 'upload';
    this.apiFileUrl = this.baseApiUrl + 'files';
  }

  public downloadFile(file: string): Observable<HttpEvent<Blob>> {
    return this.httpClient.request(new HttpRequest(
      'GET',
      `${this.apiDownloadUrl}?file=${file}`,
      null,
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  get_unique_string (strLength, charSet="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789") {
    var result = [];

    strLength = strLength || 5;
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    while (--strLength) {
        result.push(charSet.charAt(Math.floor(Math.random() * charSet.length)));
    }

    return result.join('');
  }

  public uploadFile(file: Blob, action: string, data?: any): Observable<HttpEvent<void>> {
    const formData = new FormData();
    const emptyData  = new FormData();
    let aName;
    let file_name_array = file.type.toString().split("/");
    let file_extension = file_name_array[1];
    const actionType = action;

    switch (action) {
      case "default": aName=action;
        action = this.get_unique_string("8")+"." + file_extension;
        break;
      case "logo":
        aName=action;
        action += ".png";
        break;
      case "foodtype":
        aName=action;
        if (file_extension !== "png") action = data.code + "." + 'png'; else action = data.code + "." + file_extension;
        break;
      case "goods":
        aName=action;
        this.goods = data;
        action =  this.goods.code + "."+'jpg';
        break;
      case "slider":
        aName=action;
        action =  data+"."+'jpg';
        break;
      default:
        break;
    }

    formData.append('file', file, action);
    
    if(aName == "logo" && file.size > 150000) {
      console.error('LOGO/لوگو is too big! '+ file_extension +' '+ file.size);
      this.sizeErr = file.size; this.typeErr = file.type;
      this.fileErr = 'حجم لوگو بیشتر از حد مجاز است!';
      this.toast( 'حجم لوگو بیشتر از حد مجاز است!');
      return this.httpClient.request(new HttpRequest('POST',this.apiUploadUrl,emptyData,{reportProgress: true}));
    }
    if (aName == "goods" && file.size > 500000) { //اگر حجم فایل بزرگ تر از 500 کیلوبایت بود، خطا
      console.error('تصویرکالا is too big! '+ file_extension +' '+ file.size);
      this.sizeErr = file.size; this.typeErr = file.type;
      this.fileErr = 'حجم تصویر بیشتر از حد مجاز است!';
      this.toast( 'حجم تصویر بیشتر از حد مجاز است!');
      return this.httpClient.request(new HttpRequest('POST',this.apiUploadUrl,emptyData,{reportProgress: true}));
    }
    if (aName == "foodtype" && file.size > 500000) {
      console.error('تصویر سرگروه is too big! ' + file_extension + ' ' + file.size);
      this.sizeErr = file.size; this.typeErr = file.type;
      this.fileErr = 'حجم تصویر بیشتر از حد مجاز است!';
      this.toast('حجم تصویر بیشتر از حد مجاز است!');
      return this.httpClient.request(new HttpRequest('POST', this.apiUploadUrl, emptyData, { reportProgress: true }));
    }
    if (aName == "slider" && file.size > 500000) {
      this.fileErr = 'حجم تصویر اسلاید بیشتر از حد مجاز است!';
      this.toast('حجم تصویر اسلاید بیشتر از حد مجاز است!');
      return this.httpClient.request(new HttpRequest('POST', this.apiUploadUrl, emptyData, { reportProgress: true }));
    }
    const fileUpload = new FileUploadModel();
      fileUpload.action = actionType;
      fileUpload.ufile = file;
      let params = new HttpParams();
      params.append('Action', '1');
      formData.append('Action', actionType);
      // .set('password','12345678');
      return this.httpClient.request(new HttpRequest(
        'POST',
        this.apiUploadUrl,
         formData,
         {
           reportProgress: true,
           params: params,
         }
      ));
    }


  public getFiles(): Observable<string[]> {
    return this.httpClient.get<string[]>(this.apiFileUrl);
  }

  setPath(file: any) {
    this.fileUrl = file;
    this.fileName = file.name;
  }
}
export class FileUploadModel{
  public  ufile :any;
  public  action :any;
}
